import React from 'react';
import { Loader } from 'commons-ui';

import usePriorityList from './usePriorityList';
import { styles } from './updatePriorityList.style';
import PriorityTags from './PriorityListTags';

const UpdatePriorityList: React.FC<{}> = () => {
	const {
		cashbackPriorityList,
		bonusPriorityList,
		submitBonusPriority,
		submitCashbackPriority,
		bonusInputText,
		cashbackInputText,
		handleBonusInputChange,
		handleCashbackInputChange,
		showLoader
	} = usePriorityList();
	return (
		<>
			{showLoader && <Loader />}
			<div style={styles.priorityList}>
				<h2>Bonus Priority</h2>
				<PriorityTags priorities={bonusPriorityList} />
				<div style={styles.updateSection}>
					<textarea
						value={bonusInputText}
						style={styles.textarea}
						rows='5'
						onChange={handleBonusInputChange}
						placeholder='Enter bonus priorities'
					/>
					<button type='button' onClick={submitBonusPriority} style={styles.button}>
						Update Bonus Priorities
					</button>
				</div>
			</div>
			<div style={styles.priorityList}>
				<h2>Cashback Priority</h2>
				<PriorityTags priorities={cashbackPriorityList} />
				<div style={styles.updateSection}>
					<textarea
						value={cashbackInputText}
						style={styles.textarea}
						rows='5'
						onChange={handleCashbackInputChange}
						placeholder='Enter cashback priorities'
					/>
					<button type='button' onClick={submitCashbackPriority} style={styles.button}>
						Update Cashback Priorities
					</button>
				</div>
			</div>
		</>
	);
};
export default UpdatePriorityList;
